import _ from 'lodash';
import * as actions from 'actions/types';
import {
  isAcceptedString,
  isUnderReviewString,
  isCompleteString
} from 'helpers/RequestTestsHelper';
import { isInitial } from 'helpers/RequestHelper';

const fetchModels = (action, state) => {
  if (!action.payload.data) return state;
  return { ...state, models: action.payload.data.data };
};

const fetchRequests = (action, state) => {
  if (!action.payload.data) return state;

  const { payload } = action;
  const { status, data } = payload;

  if (status === 200) {
    if (data) {
      return { list: data.data, pages: data.meta };
    }
  } else return { list: [], pages: { TOTALRECORDS: 0 } };
};

const fetchRequestsForTesting = (action, state) => {
  if (!action.payload.data) return state;

  const { payload } = action;
  const { status, data } = payload;

  if (status === 200) {
    if (data) {
      const list = _.filter(data.data, req => {
        const { fccid, testingstatus, requesttypeid } = req;
        const hasFccId = String(fccid).length !== 0;
        return (
          // test is accepted or under review
          isAcceptedString(testingstatus) ||
          isUnderReviewString(testingstatus) ||
          // initial req type w/o fccid and test status is complete
          (isInitial(requesttypeid) &&
            isCompleteString(testingstatus) &&
            !hasFccId)
        );
      });
      return { list, pages: data.meta };
    }
  } else return { list: [], pages: { TOTALRECORDS: 0 } };
};

const fetchUnpaid = (action, state) => {
  if (!action.payload) return state;
  return { ...state, unpaid: action.payload };
};

export default function(state = null, action) {
  switch (action.type) {
    case actions.FETCH_MODEL_LIST:
      return fetchModels(action, state);
    case actions.FETCH_APPROVE_WAITING_REQUESTS:
    case actions.FETCH_CERTIFICATION_REQUESTS:
      return fetchRequests(action, state);
    case actions.FETCH_REQUEST_FOR_TESTING:
      return fetchRequestsForTesting(action, state);
    case actions.CLEAR_REQUESTS:
      return null;
    case actions.FETCH_UNPAID_REQUESTS:
      return fetchUnpaid(action, state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/requests.js